module.exports = __webpack_public_path__ + "static/media/mgd-screenshot.2b3c4eff.jpg";